import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import BulkJobFailuresTab from './BulkJobFailuresTab'

const STORAGE_KEY = 'claimErrors_filters'
const defaultFilters = () => ({
  page: 1,
  per_page: 10,
  start_date: moment().format('YYYY-MM-DD'),
  end_date: moment().format('YYYY-MM-DD'),
  file_number: '',
  patient_name: '',
  status: '',
  job_type: 'submit'
})

function ClaimErrorsTab() {
  const { t } = useTranslation()
  const [filters, setFilters] = useState(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY)
      if (stored) {
        const parsed = JSON.parse(stored)
        return { ...defaultFilters(), ...parsed, page: Number(parsed?.page) || 1, per_page: Number(parsed?.per_page) || 10 }
      }
    } catch (error) {
      console.warn('Failed to parse stored claim errors filters:', error)
    }
    return defaultFilters()
  })

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(filters))
  }, [filters])

  return <BulkJobFailuresTab filters={filters} setFilters={setFilters} />
}

export default ClaimErrorsTab
